import script from "./TempG.vue?vue&type=script&lang=ts&setup=true"
export * from "./TempG.vue?vue&type=script&lang=ts&setup=true"

import "./TempG.vue?vue&type=style&index=0&id=67926df6&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67926df6"]])

export default __exports__